module.exports = __webpack_public_path__ + "img/AX-kortlogo-rgb.fcb3ccaa.png";